import request from '@/utils/request'

/*
 * 查询订单
 */
export function fetchOrder (status, page) {
  return request.request(
    `/order_resource`,
    {
      status,
      page
    },
    {method: 'get'}
  )
}

/*
 * 查询订单详情
 */
export function fetchOrderDetail (orderId) {
  return request.request(
    `/order_resource/${orderId}`,
    {},
    {method: 'get'}
  )
}

/*
 * 查询订单详情
 */
export function orderPay (orderId) {
  return request.request(
    `payment/request`,
    {order_id: orderId},
    {method: 'post'}
  )
}

/*
 * 查询稿件
 */
export function fetchManuscripts (taxonomy) {
  return request.request(
    `/manuscripts`,
    {
      taxonomy,
      used_status: -1,
      page: 1
    },
    {method: 'get'}
  )
}

/*
 * 选择稿件
 */
export function chooseManuscript (orderId, manuscriptId) {
  return request.request(
    `/order_resource/${orderId}`,
    {manuscript_id: manuscriptId},
    {method: 'put'}
  )
}

/*
 * 支付接口 获取charge包  用来传给pingpp
 */
export function createChargePackage (data) {
  return request.request(
    `/payment/recharge`,
    data,
    {method: 'post'}
  )
}



// WEBPACK FOOTER //
// ./src/api/order.js